import React, { useCallback, useEffect, useState } from "react";
import * as Styles from "../../../../common-deprecated/styles/v2/toyota/components/Form";
import { TradeInAemResolveItemType, type TradeInAemResolveItemConfig } from "../../../utils/types";
import { useTradeInAemLabel } from "../../../utils/labels";
import { useTradeInAemDispatch, useTradeInAemSelector } from "../../../redux/store";
import { tradeInAemSetResolveVehicle } from "../../../redux/actions/TradeInAemFindVehicleActions";

type Props = {
    formItem: TradeInAemResolveItemConfig;
    disabled: boolean;
};

const FindVehicleResolveInput = ({ formItem, disabled }: Props): JSX.Element | null => {
    const dispatch = useTradeInAemDispatch();
    const resolveVehicle = useTradeInAemSelector((state) => state.tradeInAemFindVehicle.resolveVehicle);
    const vehicle = useTradeInAemSelector((state) => state.tradeInAemVehicle.vehicle);

    const titleLabel = useTradeInAemLabel(formItem.labelKey);

    const [localInput, setLocalInput] = useState((vehicle?.[formItem.vehicleProperty] as string) || "");

    const handleInput = useCallback((): void => {
        if (resolveVehicle?.[formItem.vehicleProperty] !== undefined) {
            dispatch(
                tradeInAemSetResolveVehicle({
                    ...resolveVehicle,
                    [formItem.vehicleProperty]: localInput,
                }),
            );
        }
    }, [localInput, resolveVehicle, formItem.vehicleProperty, dispatch]);

    // If the localInput contains data, but the store doesn't have this value yet, ensure that this gets propagated once already.
    // This is to ensure that the other resolve options know this input field already contains some data.
    // Without this, the other resolve options will remain disabled until handleInput gets triggered onBlur.
    useEffect(() => {
        const vehicleProperty = resolveVehicle[formItem.vehicleProperty];
        const vehiclePropertyIsEmpty = !vehicleProperty || typeof vehicleProperty === "object";
        if (!!localInput && vehiclePropertyIsEmpty) handleInput();
    }, [localInput, resolveVehicle, formItem.vehicleProperty, handleInput]);

    if (formItem.type !== TradeInAemResolveItemType.Input) return null;

    return (
        <Styles.InputField mt={2}>
            <Styles.InputLabel htmlFor={formItem.vehicleProperty}>
                {titleLabel}
                {formItem.required && <Styles.MandatoryField largeFontSize>*</Styles.MandatoryField>}
            </Styles.InputLabel>
            <Styles.Select>
                <input
                    disabled={disabled}
                    placeholder={titleLabel}
                    value={localInput}
                    onChange={(event) => {
                        setLocalInput(event.target.value);
                    }}
                    onBlur={handleInput}
                />
            </Styles.Select>
        </Styles.InputField>
    );
};

export default FindVehicleResolveInput;
